{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "Accents and special characters",
  "account": "Account",
  "activity": "Activity",
  "actor": "Actor {{number}}",
  "actor_2": "Actor 2",
  "actor_name": "Actor name",
  "actor_voice": "Actor voice",
  "add_alternatives": "Add alternatives",
  "add_another_reply": "Add another reply",
  "add_answer": "Add Answer",
  "add_courses": "Add Courses",
  "add_image": "Add Image",
  "add_image_desc": "Add an image to your exercise!",
  "add_link": "Add Link",
  "add_link_desc": "Add a link to your exercise!",
  "all_languages": "All languages",
  "all_levels": "All levels",
  "all_steps_complete": "All steps complete",
  "alternative_versions": "Alternative versions",
  "archive_recording_error": "There was a problem archiving the recording",
  "assign": "Assign",
  "attach_file": "Attach file",
  "bot_not_found": "Chatbot not found",
  "bot_not_found_desc": "We couldn't find this chatbot. It may have been deleted or made private.",
  "categories": "Categories",
  "chart": "Chart",
  "choose_length_of_roleplay": "Choose the length of the scenario",
  "clear": "Clear",
  "close_pdf": "Close PDF",
  "comma_seperated_domains": "Comma separated domains",
  "community": "Community",
  "datetime": "Date and time",
  "days": "days",
  "days_late": "{{count}} days late",
  "discussion": "Discussion",
  "download_error": "There was a problem downloading the file",
  "editor_mode": "Editor mode",
  "email_notifications": "Email Notifications",
  "enter_linguistic_goal": "Enter a linguistic goal",
  "add_new": "Add new",
  "add_phrase": "Add phrase",
  "add_phrase_desc": "Add a new {{language}} phrase for people to learn",
  "add_phrases": "Add Phrases",
  "add_phrases_to_enable_exercise": "Add phrases to enable exercise",
  "add_question": "Add Question",
  "add_question_desc": "Ask a comprehension question, The question can have multiple correct answers. The order of the answers is how they will appear during the exercise.",
  "add_review": "Add Review",
  "add_review_desc": "Share your thoughts below",
  "add_script": "Add Script",
  "add_section": "Add section",
  "add_substitution": "Add substitution",
  "add_substitution_desc": "With substitutions, you can see to it that 'what's' is expanded into 'what is' instead -- allowing you better control over how you reply to the user's message!",
  "add_topic": "Add topic",
  "add_topic_desc": "Topics are logical groupings of triggers. When a user is in a topic, they can only match triggers that belong to that topic.",
  "add_topic_to_section": "Add topic to the {{sectionId}} section",
  "add_trigger": "Add trigger",
  "add_trigger_desc": "A trigger is a line of text that is used to match the user's message.",
  "add_variable": "Add variable",
  "add_variable_desc": "Chatbot variables are pieces of information that describe your chatbot. With chatbot variables, we can write replies in which the chatbot can tell the user a little something about itself.",
  "add_voice": "Add voice",
  "all": "All",
  "all_topics_completed": "All topics completed",
  "alternatives": "Alternatives",
  "alternatives_desc": "A list of words or phrases which can be reused in your chatbot.",
  "alternatives_name": "Name",
  "alternatives_value": "List of words (comma-separated)",
  "answer": "Answer",
  "new_answer_placeholder": "Type your answer here",
  "answer_message_100": "Perfect, Great work",
  "answer_message_90": "You are getting there, Keep trying",
  "answer_message_95": "That was close, You're nearly there",
  "answer_message_wrong": "That wasn't quite right",
  "answer_method": "Answer Method",
  "answers": "Answers",
  "attempt": "Attempt",
  "attempt_info": "Attempt Info",
  "attempt_messages": "Exercise Attempt",
  "attempt_table": "Attempts",
  "auto_translate": "Allow students to translate messages into their native language",
  "auto_translate_phrase": "Auto translate phrase",
  "auto_generate_phrase_translation": "Generate Translations",
  "avg_pronunciation_score": "Avg Pronunciation Score",
  "average_pronunciation_score_tooltip": "Average pronunciation score is",
  "B1": "B1",
  "B2": "B2",
  "back": "Back",
  "back_to_course": "Back to Course",
  "blog": "Blog",
  "bot": "Chatbot",
  "bot-listen-and-speak": "Listen & Speak Chatbot",
  "all_modes": "All modes",
  "bot_information": "Chatbot Information",
  "bot_intro_message": "Chatbot introduction message",
  "bot_intro_message_helper_text": "Leave empty if you want the student to start the conversation.",
  "bot_name": "Chatbot name",
  "bot_outputs": "Chatbot Outputs",
  "bot_reply": "Chatbot Reply",
  "bot_settings": "Chatbot Settings",
  "bot_title": "Chatbot title",
  "bot_voice": "Chatbot voice",
  "bots": "Chatbots",
  "bots_not_found_desc": "Create the first chatbot today",
  "bots_not_found_title": "No bots found",
  "C1": "C1",
  "C2": "C2 ",
  "cancel": "Cancel",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "novice": "Novice",
  "intermediate": "Intermediate",
  "advanced": "Advanced",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "Change app colours",
  "change_language": "Change language",
  "chatbot_exercise_desc": "Practice a conversation with guided prompts.",
  "chatbots": "Chatbots",
  "choose_avatar": "Choose Nuala",
  "choose_from_file": "Choose from file",
  "classroom_code": "Classroom code",
  "classroom_code_label": "Enter classroom code",
  "classroom_code_not_valid": "Classroom code not valid",
  "classroom_created": "Classroom created",
  "classroom_deleted": "Classroom deleted",
  "classroom_information": "Classroom information",
  "classroom_name": "Classroom name",
  "classroom_not_found": "Classroom not found",
  "classroom_not_found_desc": "This classroom may have been deleted",
  "classroom_load_error": "Couldn't load this classroom",
  "classroom_load_error_desc": "Something went wrong while loading this classroom. Please try again.",
  "classroom_settings": "Classroom Settings",
  "classrooms": "Classrooms",
  "classrooms_not_found_desc": "Create the first classroom today",
  "classrooms_not_found_title": "No classrooms found",
  "collaborators": "Collaborators (optional)",
  "color": "Colour",
  "community_templates": "Community Templates",
  "completed": "Completed",
  "completed_icon": "Completed icon",
  "completion": "Completion",
  "completions": "Completions",
  "confirmation": "Confirmation",
  "contact_form": "Contact Us",
  "continue": "Continue",
  "continue_exercise": "Continue Exercise",
  "continue_learning": "Continue Learning",
  "continue_teaching": "Continue Teaching",
  "copied": "Copied",
  "copy_to_clipboard": "Copy to clipboard",
  "correct": "Correct",
  "correct_answer": "Correct Answer",
  "correct_answer_percentage": "Correct Answer Percentage",
  "course": "Course",
  "course_code": "Course code",
  "course_code_label": "Enter course code",
  "course_code_not_valid": "Course code not valid",
  "course_created": "Course created",
  "course_deleted": "Course deleted",
  "course_information": "Course information",
  "course_name": "Course name",
  "course_not_found": "Course not found",
  "course_not_found_desc": "This course may have been deleted",
  "course_outline": "Course Outline",
  "course_progress": "Course Progress",
  "course_settings": "Course settings",
  "courses": "Courses",
  "courses_not_found_desc": "Create the first course today",
  "courses_not_found_title": "No courses found",
  "create": "Create",
  "create_bot": "Create chatbot",
  "create_classroom": "Create Classroom",
  "create_course": "Create Course",
  "create_course_section": "Create course section",
  "create_course_section_desc": "Its up to you how to structure the course, Example structures are 'Beginner, Intermediate, Advanced' or 'Week 1, Week 2, Week 3'",
  "create_duplicate": "Create Duplicate",
  "create_topic": "Create topic",
  "created_courses": "Created courses",
  "creation_visibility": "Public content can be used as a starting point for other educators creations.",
  "creator": "Creator",
  "creator_instructions": "Teacher Instructions",
  "creator_instructions_placeholder": "You can add a formatted instruction message for a course collaborator here\n\ne.g. \"Welcome to the chatbot, Here is how you can customize this chatbot for your students...\"",
  "customization": "Customization",
  "dark_theme": "Dark Theme",
  "dark_theme_desc": "Turns the light surfaces of the page dark, creating an experience ideal for night.",
  "date": "Date",
  "delete_bot": "Delete Chatbot",
  "delete_bot_confirmation": "Are you sure you want to delete this chatbot?",
  "delete_classroom": "Delete Classroom",
  "delete_classroom_confirmation": "Are you sure you want to delete this classroom?",
  "delete_course": "Delete course",
  "delete_course_confirmation": "Are you sure you want to delete this course?",
  "delete_phrase": "Delete Phrase",
  "delete_phrase_confirmation": "Are you sure you want to delete this phrase?",
  "delete_picture": "Delete Picture",
  "delete_review": "Delete Review",
  "delete_review_confirmation": "Are you sure you want to delete your review?",
  "delete_roleplay": "Delete Scenario",
  "delete_roleplay_confirmation": "Are you sure you want to delete this scenario?",
  "delete_section": "Delete section",
  "delete_section_confirmation": "Are you sure you want to delete this section?",
  "delete_topic": "Delete topic",
  "delete_topic_confirmation": "Are you sure you want to delete this topic?",
  "description": "Description",
  "difficulty": "Difficulty",
  "difficulties": "Difficulties",
  "disable": "Disable",
  "disabled": "Disabled",
  "display": "Display",
  "display_classroom_code": "Display classroom code",
  "download_csv_file": "Download",
  "drop_csv_file_or_click_to_upload": "Drop CSV file or click to upload.",
  "edit": "Edit",
  "edit_bot": "Edit Chatbot",
  "edit_discussion": "Edit Discussion",
  "edit_roleplay": "Edit Scenario",
  "email": "Email",
  "enable": "Enable",
  "enabled": "Enabled",
  "enrolment_key": "Enrolment key",
  "enrolment_key_not_valid": "Enrolment key not valid",
  "enter_private_key": "Enter Enrolment Key",
  "error_generating_discussion": "There was a problem generating the discussion",
  "exercise": "Exercise",
  "exercise_complete": "Exercise Complete",
  "exercise_completed_icon": "{{name}} completed {{counter}} time",
  "exercise_completion": "completed {{exercise}} exercise '{{id}}'",
  "exercise_in_progress": "started {{exercise}} exercise '{{id}}'",
  "exercise_info": "Exercise info",
  "exercise_no_longer_available": "This exercise is no longer available",
  "exercises": "Exercises",
  "exercises_completed": "Exercises completed",
  "exercise_progress_bar": "Exercise progress bar",
  "exercises_completed_icon": "{{name}} completed {{counter}} times",
  "exit": "Exit",
  "expand": "Expand",
  "fill_in_contact_form": "Please fill in the form below",
  "find_bot": "Find chatbot",
  "find_classroom": "Find Classroom",
  "find_course": "Find Course",
  "find_roleplay": "Find scenario",
  "finish": "Finish",
  "finish_exercise": "Finish exercise",
  "for_lang": "I speak",
  "formatting_options": "Formatting Options",
  "fri": "Fri",
  "from": "From",
  "fullscreen": "Fullscreen",
  "generate_definitions_info": "Generate definitions for the phrases in this list.",
  "generating": "Generating",
  "get_started": "Get Started",
  "go_back": "Go Back",
  "go_back_to_topic": "Go back to topic",
  "go_to": "Go to",
  "group_information_form_title": "Tell us about your group",
  "group_member_limit": "Group member limit",
  "group_name": "Group name",
  "group_picture": "Group picture",
  "group_subscription_form_title": "Set up the group subscription",
  "help": "Help",
  "hidden": "Hidden",
  "hide": "Hide",
  "hide_bot": "Hide chatbot",
  "hide_chatbots_exercise": "Hide bots",
  "hide_listening_exercise": "Hide listening exercise",
  "hide_menu": "Hide Menu",
  "hide_options": "Hide options",
  "hide_pronunciation_exercise": "Hide pronunciation exercise",
  "hide_roleplay": "Hide scenario",
  "hide_roleplays_exercise": "Hide scenarios",
  "hide_section": "Hide section",
  "hide_topic": "Hide topic",
  "hide_translation_exercise": "Hide translation exercise",
  "hide_word_bank": "Hide Word Bank",
  "hide_from_students": "Hide from Students",
  "home": "Home",
  "how_to_join_find_button": "Look for the {{button}} button and click on it.",
  "how_to_join_get_ready": "Get ready to play.",
  "how_to_join_intro": "To join the game, follow these steps:",
  "how_to_join_open_classroom": "Open the classroom {{classroom}} or scan its QR Code below",
  "how_to_join_sign_in": "Sign in to your account.",
  "how_to_join_title": "How to Join the Game",
  "in_game": "In Game",
  "in_progress": "Continue Playing",
  "incorrect": "Incorrect",
  "insert_bold": "Insert bold",
  "insert_italic": "Insert italic",
  "insert_link": "Insert link",
  "insert_photo": "Insert photo",
  "instruction_message": "Instructions",
  "join": "Join",
  "join_classroom": "Join Classroom",
  "join_code_desc": "Students can use the code below to join",
  "join_course": "Join Course",
  "join_date": "Join Date",
  "joined": "Joined",
  "joined_classroom": "Joined classroom",
  "joined_course": "Joined course",
  "language": "Language",
  "language_phrase": "{{language}} Phrase",
  "language_translation": "{{language}} Translation",
  "learn": "Learn",
  "learn_for_speakers_of": "{{learnLang}} for {{forLang}} speakers",
  "learn_lang": "I want to learn",
  "loading": "Loading",
  "loading_topics": "Loading topics",
  "more_definitions": "More definitions",
  "more_translations": "More translations",
  "new": "New",
  "no_chatbot_templates": "No templates available",
  "no_phrases": "No phrases",
  "no_topics_available": "No topics available",
  "not_in_game": "Not In Game",
  "on": "on",
  "open_image_library": "Open image library",
  "perfect_click_finish_create_group": "Perfect! Click Finish to create your group.",
  "phrase_group_game_in_progress_icon": "{{name}} in progress",
  "phrase_lists_error": "There was a problem loading the phrase lists",
  "player": "player",
  "players": "players",
  "please_select_a_textfield": "Please select a text field",
  "preview_pdf": "Preview PDF",
  "print": "Print",
  "questions": "Questions",
  "recommended": "Recommended",
  "record_unsupported": "Recording is not supported in this browser",
  "refresh": "Refresh",
  "result": "Result",
  "retry": "Retry",
  "roleplay_not_found": "Scenario not found",
  "roleplay_not_found_desc": "We couldn't find this scenario. It may have been deleted or made private.",
  "save_definitions_error": "There was a problem saving the definitions",
  "scenarios": "Scenarios",
  "schedule": "Schedule",
  "script_not_found": "Script not found",
  "script_not_found_desc": "We couldn't find this script. It may have been deleted or made private.",
  "search_images": "Search images",
  "see_more_pronunciations": "See more pronunciations",
  "send": "Send",
  "show_phrase_list": "Show Phrase List",
  "student_limit": "Student limit",
  "submit": "Submit",
  "submitting": "Submitting",
  "subscription": "Subscription",
  "subscription_period_end": "Subscription period end",
  "subscription_status": "Subscription status",
  "table": "Table",
  "teach": "Teach",
  "leave_classroom": "Leave Classroom",
  "leave_classroom_confirmation": "Are you sure you want to leave this classroom?",
  "leave_course": "Leave Course",
  "leave_course_confirmation": "Are you sure you want to leave this course?",
  "left_classroom": "Left classroom",
  "left_course": "Left course",
  "lets_begin": "Let's begin",
  "library": "Library",
  "link_name": "Link Name",
  "link_name_helper_text": "Enter a display name for your link",
  "link_value": "Link Url",
  "link_value_helper_text": "Enter the Url for your link",
  "listen_to_this_phrase": "Listen to this {{language}} phrase",
  "listener": "Listener",
  "listener_dialog_desc": "Choose a voice below to hear the pronunciation",
  "listening": "Listening",
  "listening_exercise_desc": "Listen and recognize phrases you hear.",
  "load_more_events": "Load more events",
  "logout": "Logout",
  "manage_course": "Manage Course",
  "members": "Students",
  "members_not_found": "No students",
  "members_not_found_desc": "No students were found",
  "message": "Message",
  "method": "Method",
  "missing_details": "Missing details",
  "mon": "Mon",
  "more_options": "More Options",
  "my_courses": "My courses",
  "name": "Name",
  "new_bots": "New Chatbots",
  "new_courses": "New Courses",
  "new_roleplays": "New Scenarios",
  "next": "Next",
  "next_with_progress": "Next ({current} of {total})",
  "no_activity_found": "No activity found",
  "no_courses_found": "No courses found",
  "no_results_found": "No results found",
  "nualang_templates": "Templates",
  "only_available_on_chrome": "Only available on Chrome",
  "open_in_google_sheets": "Open in Google Sheets",
  "open_search_student_name_filters": "Open search student name filters",
  "search_student_name": "Search student name",
  "option": "Option",
  "optional": "Optional",
  "or_choose_from_one_of_the_following": "Or choose from one of the following",
  "percentage_complete": "Percentage Complete",
  "phrase": "Phrase",
  "phrases": "Phrases",
  "play_again": "Play Again",
  "plays": "{{number}} Plays",
  "popular_courses": "Popular Courses",
  "popular": "Popular",
  "preview": "Preview",
  "previous": "Previous",
  "private": "Private",
  "problem": "There was a problem",
  "problem_creating": "There was a problem creating",
  "problem_deleting": "There was a problem deleting",
  "problem_getting_reply": "There was a problem getting reply",
  "problem_loading": "There was a problem loading",
  "problem_sending_contact_form": "Problem sending contact form",
  "profile": "Profile",
  "profiles": "Profiles",
  "progress_icon": "Progress Icon",
  "pronounce_this_phrase": "Pronounce this phrase",
  "pronunciation": "Pronunciation",
  "pronunciation_exercise_desc": "Practice speaking phrases naturally and clearly.",
  "public": "Public",
  "question": "Question",
  "new_question_placeholder": "Type your question here",
  "quit": "Quit",
  "record_message": "Record Message",
  "records": "Records",
  "redo_action": "Redo",
  "remove": "Remove",
  "remove_card": "Remove Card",
  "remove_bot": "Remove Chatbot",
  "remove_roleplay": "Remove Scenario",
  "remove_classroom_member": "Remove Classroom Student",
  "remove_classroom_member_confirmation": "Are you sure you want to remove this student from your classroom",
  "remove_member": "Remove Student",
  "member_removed_from_classroom": "Student removed from classroom",
  "reply": "Reply",
  "reply_options": "Reply options",
  "reply_options_are_disabled": "Reply options are disabled",
  "reply_options_desc": "Allow students to pick the correct reply from a list of options",
  "report_views": "Views",
  "required_for_private_classrooms": "Required for private classrooms",
  "required_for_private_courses": "Required for private courses",
  "reset": "reset",
  "restart_exercise": "Restart Exercise",
  "return_to_course": "Return to Course",
  "review_content": "Review Content",
  "review_title": "Review Title",
  "reviews": "Reviews",
  "reviews_not_found": "No Reviews",
  "reviews_not_found_desc": "No reviews were found",
  "role_played": "Role Played",
  "roleplay": "Scenario",
  "roleplay_exercise_desc": "Step into a scene and practice with a dialogue.",
  "roleplays_not_found_desc": "Create the first scenario today",
  "roleplay_information": "Scenario Information",
  "roleplay_name": "Scenario name",
  "roleplay_settings": "Scenario Settings",
  "roleplays": "Scenarios",
  "sat": "Sat",
  "save_changes": "Save Changes",
  "save_progress": "Save Progress",
  "show_progress": "Show Progress",
  "script": "Script",
  "search": "Search",
  "search_for_student": "Search for Student",
  "section": "Section",
  "section_name": "Section name",
  "section_visibility": "Section Visibility",
  "sections_not_found": "No sections found",
  "sections_not_found_desc": "",
  "select_a_template": "Select a Template",
  "select_file": "Select file",
  "select_file_desc": "Drop file here or click to browse your machine",
  "select_files": "Select files",
  "select_the_from_date": "Select the From Date",
  "select_the_to_date": "Select the To Date",
  "settings": "Settings",
  "share": "Share",
  "share_via": "Share via",
  "show_bot": "Show chatbot",
  "show_chatbots_exercise": "Show bots",
  "show_listening_exercise": "Show listening exercise",
  "show_menu": "Show Menu",
  "show_options": "Show options",
  "show_pronunciation_exercise": "Show pronunciation exercise",
  "show_roleplay": "Show scenario",
  "show_roleplays_exercise": "Show scenarios",
  "show_section": "Show section",
  "show_topic": "Show topic",
  "show_translation_exercise": "Show translation exercise",
  "show_word_bank": "Show Word Bank",
  "show_to_students": "Show to Students",
  "skip": "Skip",
  "skip_copy_topic": "Skip",
  "skipped": "Skipped",
  "speak": "Speak",
  "speakers_of": "Speakers Of",
  "start": "Start",
  "start_course": "Start Course",
  "stop": "Stop",
  "stop_recording": "Stop Recording",
  "student_instructions": "Student Instructions",
  "student_instructions_placeholder": "Student Instructions:\nYou can add your formatted instruction message in here\n\ne.g. \"Welcome to the chatbot, you can start by typing in hello\"",
  "subject": "Subject",
  "substitution_desc": "Make changes to the user's message before checking triggers.",
  "substitution_name": "Original text",
  "substitution_name_helper_text": "The original text that may appear in the user's message",
  "substitution_value": "Substitution text",
  "substitution_value_helper_text": "Should not contain any special symbols or punctuation, and should also be lowercased",
  "substitutions": "Substitutions",
  "sun": "Sun",
  "text": "Text",
  "thank_you_for_submitting": "Thank you for submitting, we will get in contact with you as soon as possible.",
  "the_default_topic_is_random": "The default topic is random",
  "thu": "Thu",
  "time": "Time",
  "time_spent": "Time Spent",
  "to": "To",
  "toggle_theme": "Toggle light/dark theme",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "topic": "Topic",
  "topic_code": "Topic code",
  "topic_desc": "When a user is in a topic, they can only match triggers that belong to that topic.",
  "topic_image": "Topic image",
  "topic_information": "Topic Information",
  "topic_settings": "Topic Settings",
  "topic_title": "Topic Title",
  "topic_name": "Topic name",
  "topic_not_found": "Topic not found",
  "topic_not_found_desc": "This topic may have been deleted",
  "topics": "Topics",
  "translate": "Translate",
  "translate_is_disabled": "Translate is disabled",
  "translate_this_phrase": "Translate this phrase",
  "translation": "Translation",
  "translation_exercise_desc": "Check your understanding of key phrases.",
  "translations": "Translations",
  "trigger_value": "Trigger text",
  "trigger_value_helper_text": "Should not contain any special symbols or punctuation, and should also be lowercased",
  "triggers": "Triggers",
  "triggers_desc": "A trigger is a line of text that is used to match the user's message.",
  "tue": "Tue",
  "type": "Type",
  "unarchive": "Unarchive",
  "undo_action": "Undo",
  "update": "Update",
  "update_image": "Update Image",
  "update_link": "Update Link",
  "update_phrase": "Update Phrase",
  "update_phrase_desc": "Make changes to this existing phrase",
  "update_picture": "Update Picture",
  "update_question": "Update Question",
  "update_question_desc": "Ask a comprehension question, The question can have multiple correct answers. The order of the answers is how they will appear during the exercise.",
  "update_recording_error": "There was a problem updating the recording",
  "update_review": "Update Review",
  "update_review_desc": "Update Review Description",
  "update_section": "Update Section",
  "update_section_desc": "Its up to you how to structure the course, Example structures are 'Beginner, Intermediate, Advanced' or 'Week 1, Week 2, Week 3'",
  "update_substitution": "Update substitution",
  "update_topic": "Update topic",
  "update_trigger": "Update trigger",
  "update_variable": "Update variable",
  "upgrade": "Upgrade",
  "upload_phrases": "Upload Phrases",
  "upload_phrases_desc": "Create and upload a csv file like the example below.",
  "upload_phrases_example_phrase_1": "hello",
  "upload_phrases_example_phrase_2": "goodbye",
  "upload_phrases_example_phrase_3": "my name is",
  "upload_phrases_example_definition_1": "A word used to greet someone",
  "upload_phrases_example_definition_2": "A word used when leaving someone",
  "upload_phrases_example_definition_3": "A phrase used to tell someone your name",
  "upload_script": "Upload Script",
  "upload_script_desc": "Upload a scenario script with a csv file by using the format shown below",
  "use_keyboard": "Use Keyboard",
  "use_word_bank": "Use Word Bank",
  "user_message": "User Message",
  "user_updated": "User updated",
  "variable_desc": "Pieces of information which can be used in your chatbot.",
  "variable_name": "Variable name",
  "variable_value": "Variable value",
  "variables": "Variables",
  "vars": "Variables",
  "view_activity": "View Activity",
  "view_instruction_message": "View instructions",
  "view_outline": "View Outline",
  "view_progress": "View Progress",
  "view_report": "View Report",
  "visibility": "Visibility",
  "visit_learning_site": "Visit Learning Site",
  "voice": "Voice",
  "voice_speed_disabled": "Voice speed is not available for this voice",
  "wed": "Wed",
  "weekly_progress": "Weekly progress",
  "what_do_you_hear": "What do you hear?",
  "word_bank": "Word Bank",
  "active_now": "Active now",
  "choose_a_language": "Choose a language",
  "manage_classroom": "Manage Classroom",
  "must_question_least_correct_answer": "Must be a question and at least one correct answer.",
  "enter_name_your_voice_clip": "Enter a name for your voice clip?",
  "my_unnamed_clip": "My unnamed clip",
  "are_you_sure": "Are you sure?",
  "is_already_created_variable_overwrite": "is already a created variable, do you want to overwrite it?",
  "is_already_created_substitution_overwrite": "is already a created substitution, do you want to overwrite it?",
  "is_already_created_alternative_overwrite": "is already a created alternative, do you want to overwrite it?",
  "is_already_created_topic_overwrite": "is already a created topic, do you want to overwrite it?",
  "bring_your_bot_picture_name": "Bring your chatbot to life by giving it a picture and a name",
  "perfect_click_finish_create_bot": "Perfect, Click finish to create your new chatbot",
  "lets_start_with_some_information_about_your_bot": "Let's start with some information about your chatbot",
  "lets_start_some_information_about_classroom": "Let's start with some information about your classroom",
  "the_language_classroom_teach": "The language this classroom will teach",
  "the_language_students_classroom_speak": "The language the students of this classroom speak",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Limit access to your classroom by setting visibility to private and including an enrolment key",
  "add_collaborators": "Add collaborators",
  "perfect_click_finish_create_classroom": "Perfect, Click finish to create your new classroom",
  "perfect_click_finish_create_course": "Perfect, Click finish to create your new course",
  "lets_start_information_about_course": "Let's start with some information about your course",
  "the_language_course_teach": "The language this course will teach",
  "the_language_students_course_speak": "The language the students of this course speak",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Limit access to your course by setting visibility to private and including an enrolment key",
  "selected": "Selected",
  "perfect_click_finish_create_roleplay": "Perfect, Click finish to create your new scenario",
  "lets_start_with_information_about_roleplay": "Let's start with some information about your scenario",
  "play_bot": "Play chatbot",
  "invite": "Invite",
  "unanswered_table": "Unanswered",
  "create_roleplay": "Create Scenario",
  "roleplays_not_found_title": "No scenarios found",
  "play": "Play",
  "delete": "Delete",
  "use_wordbank_if_stuck": "Use the word bank if you need help",
  "play_bot_error": "Oops! A problem occurred with the chatbot, please try again",
  "bot_editor_preview_error": "An error has occurred. Please refer to the help pop up (question mark icon) at the top of the screen.",
  "lets_find_a_template": "Let's find a template!",
  "search_by_difficulty": "Search by difficulty",
  "search_using_keywords": "Search using keywords",
  "select_a_nualang_template": "Select a Nualang template",
  "select_a_nualang_template_desc": "Templates built by the Nualang team to help get you started.",
  "or_select_a_community_template": "Or select a community template",
  "or_select_a_community_template_desc": "Community templates are built by teachers around the world.",
  "dashboard_welcome": "Welcome, {{name}}!",
  "dashboard_welcome_desc": "Get familiar with the explore page, here are some ways to get started.",
  "enter_course_code": "Enter a course code",
  "enter_course_code_desc": "If you have a course code, enter it here.",
  "enter_classroom_code": "Enter a classroom code",
  "enter_classroom_code_desc": "If you have a classroom code, enter it here.",
  "search_nualang": "Explore Nualang",
  "search_nualang_desc": "There’s a growing community of like minded teachers developing conversations with our Nualas so there’s always something new to learn.",
  "create_nualang": "Create your own",
  "create_nualang_desc": "Create conversations and language lessons.",
  "roleplay_editor_welcome": "Getting started with the Scenario Editor",
  "roleplay_editor_options": "Select an option",
  "roleplay_editor_options_desc": "Choose a Nuala to add a new line, or add a comprehension question.",
  "roleplay_editor_share": "Share scenario",
  "roleplay_editor_play": "Play scenario",
  "bot_editor_welcome": "Getting started with the Chatbot Editor",
  "bot_editor_sidebar": "Editor sidebar",
  "bot_editor_sidebar_desc": "The sidebar is where you will be able to make changes to your chatbot.",
  "bot_editor_flow_chart": "Chatbot flow",
  "bot_editor_flow_chart_desc": "The chatbot flow shows an overview of your chatbot and gives a preview of what each message will look like.",
  "bot_editor_share": "Share chatbot",
  "bot_editor_play": "Play chatbot",
  "play_roleplay": "Play Scenario",
  "customize_appearance_of_course": "Customize the appearance of the course",
  "customize_appearance_of_classroom": "Customize the appearance of the classroom",
  "customize_appearance_of_topic": "Customize the appearance of the topic",
  "manage_courses": "Manage Courses",
  "refresh_courses": "Refresh Courses",
  "delete_script_item": "Delete Item from Script",
  "delete_script_item_confirmation": "Are you sure you want to delete this item from the script?",
  "add_message": "Add message",
  "resources": "Resources",
  "contact": "Contact",
  "sign_in": "Sign In",
  "sign_up": "Sign Up",
  "faqs": "FAQs",
  "guides": "Guides",
  "back_to_app": "Back to App",
  "notes": "Notes",
  "notes_placeholder": "Enter notes here",
  "get_in_touch": "Get in touch",
  "get_in_touch_desc": "Have questions or feedback? Send us a message.",
  "avatar_generator": "Avatar Generator",
  "avatar_generator_desc": "Make your own personal avatar",
  "upload_image": "Upload Image",
  "upload_image_desc": "Drag and drop image from your computer",
  "random": "Random",
  "done": "Done",
  "file_size_exceeded": "Image too large! Please upload an image smaller than ",
  "image_selection_failed": "Couldn't load that image. Please try a different one or upload your own.",
  "remove_course": "Remove Course",
  "courses_joined": "Courses joined",
  "courses_shared_by_other_teachers": "Courses shared by other teachers",
  "no_created_courses_match": "No created courses match these filters",
  "no_joined_courses_match": "No joined courses match these filters",
  "no_community_courses_match": "No courses match these filters",
  "courses_added": "Courses added",
  "problem_adding_courses": "There was a problem adding those courses",
  "classroom_courses_not_found_title": "No courses yet",
  "classroom_courses_not_found_desc": "This classroom does not have any courses yet.",
  "in_progress_activity": "In Progress",
  "bot_exercise_welcome": "Getting started with the Chatbot Exercise",
  "bot_exercise_restart": "Restart the chatbot!",
  "bot_exercise_keyboard_input": "Type it!",
  "bot_exercise_keyboard_input_desc": "Use the keyboard to type a message. If you need help with special characters or want to add an emoji try our helpful buttons.",
  "bot_exercise_voice_input": "Speak it!",
  "bot_exercise_voice_input_desc": "Click the microphone to use your voice and practice your pronunciation.",
  "bot_exercise_send_message": "Send it!",
  "bot_exercise_send_message_desc": "Send a message to the chatbot and get the conversation started.",
  "bot_exercise_audio_only_mic": "Speak it!",
  "bot_exercise_audio_only_mic_desc": "Tap the microphone to start. After that, just speak naturally — Nuala will listen and respond automatically for the rest of the conversation.",
  "roleplay_exercise_welcome": "Getting started with the Scenario Exercise",
  "roleplay_exercise_read_script": "Learn your lines!",
  "roleplay_exercise_read_script_desc": "Read the conversation and listen to how the words are pronounced.",
  "roleplay_exercise_select_an_actor": "Choose your role!",
  "roleplay_exercise_select_an_actor_desc": "Select the role you would like to play.",
  "roleplay_exercise_start": "Act it out!",
  "roleplay_exercise_start_desc": "Click start and use your keyboard or voice to act out the role you have chosen.",
  "listening_exercise_welcome": "Getting started with the Listening Exercise",
  "listening_exercise_speak": "Listen to the phrase!",
  "listening_exercise_speak_desc": "Click to listen to how the phrase is pronounced.",
  "listening_exercise_voice_options": "Hear a different voice!",
  "listening_exercise_voice_options_desc": "Listen to the phrase being said in different voices.",
  "listening_exercise_keyboard_input": "Type the answer!",
  "listening_exercise_keyboard_input_desc": "Use the keyboard to type the phrase you hear.",
  "listening_exercise_word_bank": "Need help?",
  "listening_exercise_word_bank_desc": "Use the word bank to select the correct answer.",
  "translation_exercise_welcome": "Getting started with the Translation Exercise",
  "translation_exercise_speak": "Listen to the phrase!",
  "translation_exercise_speak_desc": "Click to listen to how the phrase is pronounced.",
  "translation_exercise_read": "Read the phrase!",
  "translation_exercise_read_desc": "Read the phrase to be translated.",
  "translation_exercise_keyboard_input": "Type the answer!",
  "translation_exercise_keyboard_input_desc": "Use the keyboard to type the translation.",
  "translation_exercise_word_bank": "Need help?",
  "translation_exercise_word_bank_desc": "Use the word bank to select the correct answer.",
  "pronunciation_exercise_welcome": "Getting started with the Pronunciation Exercise",
  "pronunciation_exercise_speak": "Listen to the phrase!",
  "pronunciation_exercise_speak_desc": "Click to listen to how the phrase is pronounced.",
  "pronunciation_exercise_read": "Read the phrase!",
  "pronunciation_exercise_read_desc": "Read the phrase to be pronounced.",
  "pronunciation_exercise_voice_input": "Pronounce the phrase!",
  "pronunciation_exercise_voice_input_desc": "Click the microphone to use your voice and practice your pronunciation.",
  "exercise_share": "Share with others!",
  "exercise_mute": "Mute the sound!",
  "exercise_skip": "Skip!",
  "exercise_skip_desc": "Move to the next phrase, you will be able to try again at the end.",
  "exercise_restart": "Restart!",
  "what_would_you_like_to_do": "What would you like to do?",
  "i_want_to_learn": "I want to learn...",
  "i_want_to_teach": "I want to teach...",
  "add_alternative_version": "Add alternative version",
  "add_alternative_version_explanation": "Add an alternative version of the phrase to be marked as correct e.g 'You are welcome' could be an alternative to 'You're welcome'",
  "language_translation_helper_text": "Press enter / return key to add translation.",
  "change_roles": "Change roles?",
  "write_your_feedback_here": "Write your feedback here",
  "yes": "Yes",
  "you_are_human_check": "Please confirm you are human",
  "you_will_lose_your_progress_on_this_exercise": "You will lose your progress on this exercise.",
  "confirm": "Confirm",
  "general": "General",
  "shuffle_phrases": "Shuffle Phrases",
  "shuffle_phrases_desc": "Randomize the order questions are asked in the exercises.",
  "errors": "Errors",
  "missing_translation": "Missing translation",
  "missing_phrase": "Missing phrase",
  "invalid_image_domain": "Image URL must be from an approved Nualang domain",
  "row": "Row",
  "no_valid_type": "Type must be 'actor' or 'question'",
  "no_actor_text": "No text for actor",
  "no_actor_number": "Actor must have number at end e.g. actor1, actor2",
  "no_question": "No question",
  "no_answers_provided": "No answers provided",
  "no_correct_answer_provided": "No correct answer provider",
  "no_answers": "No answers",
  "duplicate_topic": "Duplicate Topic",
  "normal_mode": "Normal Mode",
  "spreadsheet_mode": "Spreadsheet Mode",
  "image": "Image",
  "delete_selected_row": "Delete selected row(s)",
  "crop_image": "Crop Image",
  "crop": "Crop",
  "zoom": "Zoom",
  "rotate": "Rotate",
  "hide_preview": "Hide Preview",
  "show_preview": "Show Preview",
  "try_again": "Try Again",
  "subscription_plan_teach": "Teach Plan",
  "subscription_plan_teacher_pro": "Teacher PRO",
  "subscription_plan_basic": "Teacher Basic",
  "subscription_plan": "Subscription Plan",
  "subscription_status_trialing": "Free Trial",
  "subscription_status_active": "Active",
  "subscription_status_canceled": "Canceled",
  "subscription_status_undefined": "Free",
  "status": "Status",
  "upgrade_plan": "Upgrade Plan",
  "manage_plan": "Manage Plan",
  "cancel_plan": "Cancel Plan",
  "your_plan": "Your Plan",
  "plan_cost": "Plan Cost",
  "next_billing_date": "Current Period End",
  "free": "Free",
  "payment_method": "Payment Method",
  "confidence_score": "The confidence percentage indicates the probability that the individual words were recognized correctly.",
  "first_name": "First Name",
  "last_name": "Last Name",
  "role": "Role",
  "school_name": "School Name",
  "school_district": "School District",
  "city": "City",
  "state": "State",
  "send_message": "Send Message",
  "pricing_page_title": "Choose your plan",
  "pricing_page_subtitle": "Pricing plans for teachers, schools and districts.",
  "pricing_page_testimonials_title": "What Teachers are saying",
  "compare_plans": "Compare Plans",
  "features": "Features",
  "upgrade_submit": "Upgrade",
  "upgrade_subscription_desc": "To access this feature you need to upgrade your account. Click Upgrade to be taken to the pricing page.",
  "upgrade_plan_explanation": "To access this feature you need to upgrade your account.",
  "upgrade_subscription_student": "This feature is available to teachers only.",
  "public_visibility_disabled_wayside": "Classrooms are managed by Wayside Publishing and must remain private.",
  "public_visibility_disabled_loading": "We're still checking your subscription. Please refresh the page if this doesn't update.",
  "public_visibility_disabled_trial": "Public classrooms aren't available during a free trial. Upgrade to a paid plan to make this classroom public.",
  "creator_not_subscribed": "This content is not joinable as the creator is not currently subscribed.",
  "sign_me_up": "Sign me up!",
  "free_trial": "FREE Trial",
  "interactive_demo": "Get a Demo",
  "news_and_updates": "News and Updates",
  "teacher": "Teacher",
  "principal": "Principal",
  "tutor": "Tutor",
  "parent": "Parent",
  "student": "Student",
  "other": "Other",
  "none": "None",
  "group_subscription_plans": "Group Subscription Plans",
  "group_plan": "Group Plan",
  "leave_group": "Leave Group",
  "joined_subscription": "Joined subscription",
  "joined_subscription_desc": "Welcome to the {{groupName}} group subscription, you are now using Teacher PRO!",
  "unable_to_join_subscription": "Unable to join subscription",
  "unable_to_join_subscription_desc": "There was an issue joining subscription, please try again later.",
  "unable_to_join_subscription_invalid_email_desc": "You cannot join this group without having one of the allowed email domains: {{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}' has reached it's student limit, contact the group admin to increase the limit.",
  "moderated_image_dialog": "Nualang detected an image that was inappropriate, unwanted, or offensive and blocked it to provide a safer user experience. Please try a different image.",
  "moderate_title": "Image Blocked",
  "recommended_courses": "Recommended Courses",
  "subscription_status_trialing_expired": "Free Trial Expired",
  "no_public_content_created": "No public content created",
  "content_tags": "Add Tags",
  "enter_info_tags": "Enter a comma separated list of tags below.",
  "add_tag": "Press enter / return key to add a tag",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators can manage courses, students, and classroom settings.",
  "add_collaborator_tag": "Press enter / return key to add a collaborator",
  "add_to_classroom": "Add to classrooms",
  "add_to_classroom_desc": "Add '{{courseName}}' to {{classroomNames}}.",
  "change_voice_speed": "Change the voice speed!",
  "extra_fast": "Super speed",
  "fast": "Very fast talker",
  "medium": "Normal speed",
  "slow": "Slow it down a bit",
  "extra_slow": "One word at a time",
  "card_ALL": "All",
  "join_classroom_to_access": "Join classroom to access",
  "join_course_to_access": "Join course to access",
  "confidence": "Confidence",
  "teach_lang": "I want to teach",
  "write_feedback": "Write Feedback",
  "allowed_domains": "Allowed school domains (optional)",
  "enter_domains_info": "Enter a comma or space separated list of school domains below.",
  "add_allowed_domains_desc": "Restrict access based on school domain e.g 'schooldomain.com'",
  "send_feedback": "Send Feedback",
  "add_feedback": "Add Feedback",
  "feedback_content": "Feedback Content",
  "report_problem": "Report problem",
  "report_problem_input_label": "Problem description",
  "update_feedback": "Update Feedback",
  "student_completes_exercise": "A student completes an exercise",
  "delete_feedback_confirmation": "Are you sure you want to delete this feedback?",
  "delete_feedback": "Delete Feedback",
  "updates_to_our_terms_of_service": "Updates to our Terms of Service",
  "email_me_when": "Email me when:",
  "new_classroom": "New Classroom",
  "student_progress": "Student Progress",
  "view_course": "View Course",
  "view_section": "View Section",
  "classroom_members_not_found_title": "No students yet",
  "classroom_members_not_found_desc": "This classroom does not have any students yet.",
  "open_topic": "Open Topic",
  "choose_game_mode": "Choose an exercise",
  "story": "Story",
  "story_description": "Listen to the conversation between the characters and answer questions to test your understanding.",
  "fill_in_blanks": "Fill in the blanks",
  "fill_in_blanks_description": "Can you correctly identify what's missing?",
  "fill_in_the_blanks": "Fill in the blanks",
  "fill_in_the_blanks_description": "Can you correctly identify what's missing?",
  "act_it_out": "Act it out",
  "act_it_out_description": "Can you select the correct response?",
  "act_it_out_listening": "Act it out - Listening",
  "act_it_out_listening_description": "Use your listening skills to select the correct response.",
  "act_it_out_speaking": "Act it out - Speaking",
  "act_it_out_speaking_description": "Practice your pronunciation by speaking your part.",
  "act_it_out_listening_speaking": "Act it out - Listening and Speaking",
  "act_it_out_listening_speaking_description": "Practice your pronunciation by speaking your part.",
  "select_role": "Select your role",
  "select_role_description": "Select the role you would like to play.",
  "mute": "Mute",
  "unmute": "Unmute",
  "replay": "Restart",
  "restart": "Restart",
  "click_to_speak": "click to speak",
  "click_to_stop": "click to stop",
  "listening_indicator": "Listening ...",
  "save_recording_to_report": "Save recording to report",
  "no_voice_recording_saved": "Voice recording was not saved",
  "classrooms_not_created": "No classrooms created",
  "select_a_classroom": "Select a classroom",
  "voice_attempt": "Voice attempt",
  "upload_variables": "Upload variables",
  "next_game": "Next Game",
  "roleplay_games": "Scenario Games",
  "roleplay_games_description": "Click on one of the cards below to play a specific game",
  "group_courses": "Group courses",
  "select": "Select",
  "classroom_creator_welcome": "Getting started with your classroom",
  "classroom_creator_welcome_free_trial": "Welcome to your 30 day free trial of Nualang! To get you started, we have setup your first classroom.",
  "classroom_creator_add_courses": "Add courses",
  "classroom_creator_add_courses_desc": "Choose how you want to add courses to the classroom.",
  "classroom_creator_add_students_email": "Invite students",
  "classroom_creator_track_progress": "Track student activity",
  "classroom_creator_track_progress_desc": "Once students have joined the classroom, click to view their progress on the courses which have been added.",
  "forLang_and_learnLang_the_same": "Learn language and speaker language are the same. Translation exercise is disabled as a result",
  "english": "English",
  "french": "French",
  "german": "German",
  "irish": "Irish",
  "italian": "Italian",
  "portuguese": "Portuguese",
  "spanish": "Spanish",
  "close": "Close",
  "last": "Last",
  "update_avatar": "Update Avatar",
  "update_avatar_desc": "Update your personal avatar",
  "invite_students": "Invite Students",
  "scan_to_open_the_classroom": "Scan to open the classroom",
  "classroom_link": "Classroom link",
  "copy": "Copy",
  "tell_students_to": "Tell students to",
  "invite_step_sign_in": "Sign in to their account.",
  "invite_step_scan": "Scan the code, or open the classroom.",
  "invite_step_tap_join": "Tap {{button}}.",
  "share_student_link_desc": "Share the instructions below to invite students to join.",
  "invite_link_desc": "Please sign in or create an account on Nualang by clicking this invite link:",
  "join_instructions_1": "This will bring you to the ",
  "join_instructions_2": "I created for you, where you'll have to click ‘Join’",
  "enrollment_key_text": "and input the key: ",
  "copy_student_instructions": "Copy student instructions",
  "or_invite_via": "Or invite via",
  "classroom": "Classroom",
  "invite_email_subject": "Invitation to join a Nualang",
  "dear_students": "Dear Students",
  "dashboard": "Dashboard",
  "preview_roleplay": "Preview Scenario",
  "roleplay_preview": "Preview",
  "roleplay_preview_decription": "Preview the full scenario script",
  "sort": "Sort",
  "sort_by": "Sort By",
  "newest": "Newest",
  "alphabetical": "Alphabetical",
  "recently_changed": "Recently Changed",
  "recently_viewed": "Recently Viewed",
  "oldest": "Oldest",
  "default": "Default",
  "clear_filters": "Clear filters",
  "member": "Student",
  "stop_speaking": "Stop Speaking",
  "agree_to_terms_and_conditions_1": "I agree to the ",
  "nualang_terms": "Nualang terms",
  "agree_to_terms_and_conditions_2": ", including acceptance of our ",
  "privacy_policy": "Privacy and Data Protection policy",
  "first_classroom_description": "This is a classroom to help students speak {{learnLang}} with confidence.",
  "upload": "Upload",
  "download": "Download",
  "classroom_creator_add_students_email_desc": "Click to explore different ways to invite students to your classroom.",
  "bot_sign_in_message": "You must be signed in to play this chatbot",
  "course_sign_in_to_access": "Sign in to access this course",
  "have_an_account": "Have an account?",
  "provide_a_little_more_information": "Provide a little more information",
  "instructions": "Instructions",
  "close_preview": "Close Preview",
  "check_recognition": "Check speech recognition",
  "checking_recognition": "Checking speech recognition ...",
  "phrase_recognised": "Phrase recognised",
  "phrase_not_recognised": "Phrase not recognised",
  "speech_recognition_info": " Checking the speech recognition allows you to determine whether or not your students will have difficulty pronouncing this phrase in our exercises.",
  "speech_recognition_error_info": "We recognised your phrase as {{recognisedPhrase}}. We recommend that you reword the phrase and/or add an alternative version.",
  "my_library": "My Library",
  "add_own_exercise_message": "Create new {{exerciseName}} using templates created by you",
  "no_exercises_in_library": "There are no {{exerciseName}} created by you.",
  "classroom_invite_feature_disabled_message": "This feature is disabled because your students will be able to join this classroom automatically.",
  "skip_navigation": "Skip Navigation",
  "generate_roleplay": "Generate Scenario",
  "choose_topic_for_roleplay": "Choose a topic for the scenario",
  "roleplay_generated": "Scenario Generated",
  "select_roleplay": "Select Scenario",
  "chatgpt_roleplay_description": "This is a scenario about {{topic}}",
  "check_answer": "Check Answer",
  "card": "Card",
  "banner": "Banner",
  "load_more": "Load More",
  "bot_input_placeholder": "Use the keyboard to type a message",
  "bot_input_mobile_placeholder": "Type a message...",
  "audio_only_mode": "Listen & Speak",
  "audio_only_tooltip": "Switch to audio-only mode",
  "switch_to_text": "Switch to text",
  "switch_to_text_tooltip": "Switch back to text mode",
  "audio_only_title": "Talk with {{botName}}",
  "audio_only_subtitle": "A fully spoken conversation — no text at all. Headphones recommended.",
  "audio_only_mode_unavailable_fallback_chat": "This exercise requires Listen & Speak mode, but it's not available on this device — continuing in Chat mode instead.",
  "microphone_ready": "Microphone ready",
  "bot_is_speaking": "Speaking...",
  "thinking_indicator": "Thinking...",
  "start_conversation": "Start the conversation",
  "stop_button_label": "Stop",
  "stop_bot_message": "Stop the chatbot voice",
  "choose_mode_text_option": "Chat",
  "choose_mode_text_option_desc": "Type or speak your answers, then read or listen to the chatbot's replies.",
  "bot_mode_in_progress_icon": "{{mode_name}} conversation currently in progress",
  "bot_mode_completed_icon": "{{mode_name}} completed {{counter}} time",
  "bot_modes_completed_icon": "{{mode_name}} completed {{counter}} times",
  "replay_button_label": "Replay",
  "replay_bot_message": "Repeat chatbot message",
  "you": "You",
  "ready_when_you_are": "Ready when you are",
  "bot_speaking_banner": "{{botName}} is speaking",
  "listening_to_you": "Listening to you",
  "bot_thinking_banner": "{{botName}} is thinking",
  "one_moment": "One moment",
  "listen_first": "Listen first",
  "tap_when_done": "Tap when you're done",
  "conversation_complete": "Conversation complete",
  "exchanges_label": "Exchanges",
  "time_spoken_label": "Time spoken",
  "review_your_turns": "Review your turns",
  "submit_to_teacher": "Submit to teacher",
  "great_job": "Great job!",
  "or": "or",
  "choose_difficulty_of_roleplay": "Choose a difficulty for the scenario",
  "child": "Child",
  "game_visibility": "Game Visiblity",
  "duplicate_course": "Duplicate Course",
  "amount_must_not_exceed_10": "Amount must not exceed 10",
  "amount_must_be_greater_than_0": "Amount must be greater than 0",
  "voice_pitch": "Voice Pitch",
  "voice_pitch_example": "Hello, My Name is {{name}}",
  "voice_pitch_disabled": "Adjusting the pitch is not possible for this voice.",
  "voice_pitch_x_low": "Very Low",
  "voice_pitch_low": "Low",
  "voice_pitch_medium": "Medium",
  "voice_pitch_high": "High",
  "voice_pitch_x_high": "Very High",
  "contact_us": "Contact Us",
  "contact_us_message": "Thank you for using Nualang. Please send your message below and we will get back to you at the earliest.",
  "expected_phrases": "Expected Phrases",
  "expected_phrases_info": "Phrases you expect your students to use during the exercise that you'd like to be recognised correctly when the student speaks. For example, if the exercise was about the weather you might want to recognise the word 'weather' more often than 'whether'",
  "add_expected_phrases": "Add Expected Phrases",
  "phrase_length_exceeded_error": "Phrase should not exceed 100 characters",
  "whats_new": "What's New",
  "wayside_subscription_message": "Your subscription is managed by Wayside Publishing",
  "select_the_correct_answer": "Select the correct answer",
  "pronunciation_score": "Pronunciation score",
  "pronunciation_score_explanation": "The pronunciation score is based on the number of words recognised correctly ({{transcriptCompletenessPercentage}}%) and how clearly they were recognised.",
  "add_course": "Add Course",
  "generate_roleplay_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "experimental_feature_desc": "New AI Feature - We would love to hear your feedback",
  "generating_roleplay": "Generating Scenario",
  "updated": "Updated",
  "exercise_completed": "Exercise Completed",
  "exercise_not_completed": "Exercise Not Completed",
  "view_topic": "View Topic",
  "view_roleplay": "View Scenario",
  "view_bot": "View Chatbot",
  "student_reports_problem": "A student reports a problem during an exercise",
  "problem_reported": "Problem reported",
  "remove_course_confirmation": "Are you sure you want to remove this course?",
  "classroom_member_limit_reached": "Classroom has reached its student limit",
  "upload_pdf": "Upload PDF",
  "remove_pdf": "Remove PDF",
  "classroom_updated": "Classroom Updated",
  "deleted": "Deleted",
  "created": "Created",
  "moderation_warning": "The following categories were detected in your uploaded image(s): ",
  "warning": "Warning",
  "use_anyways": "Use Anyways",
  "view_pdf": "View Story",
  "schedule_discussion": "Schedule discussion",
  "video_chat": "Video Chat",
  "video_chat_member": "Video Chat Member",
  "create_meeting": "Create meeting",
  "group_assignment": "Group assignment",
  "join_group": "Join Group",
  "groups": "Groups",
  "group": "Group",
  "welcome": "Welcome",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "course_updated": "Course updated",
  "overwrite_phrases": "Overwrite Phrases",
  "roleplay_game_in_progress_icon": "Scenario game currently in progress",
  "roleplay_game_completed_icon": "Scenario game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Scenario game has been completed {{counter}} times",
  "page": "Page",
  "remove_group": "Remove Group",
  "create_groups": "Create Groups",
  "select_all": "Select All",
  "unknown": "Unknown",
  "add_a_discussion_topic": "Add A Discussion Topic",
  "add_a_discussion_prompt": "Add a Discussion Prompt",
  "add_a_url_for_students_to_discuss": "Add a URL for Students to Discuss",
  "images_that_students_can_use_as_a_background_during_the_call": "Images that Students Can Use as a Background During the Call",
  "discussion_images": "Discussion Images",
  "images_for_students_to_discuss_during_the_call": "Images for Students to Discuss During the Call",
  "recording_time": "Recording Time",
  "due_date": "Due Date",
  "record_time_limit": "Record Time Limit",
  "interculturarity": "Interculturality",
  "comprehensibility": "Comprehensibility",
  "function_and_text_type": "Function and Text Type",
  "vocabulary_in_context": "Vocabulary in Context",
  "Drag_and_drop_image_from_your_computer": "Drag and Drop Image from Your Computer",
  "schedule_discussion_options": "File Size Exceeded",
  "chat_options": "Chat Options",
  "recording_info": "Submission Info",
  "discussion_id": "Discussion ID",
  "discussion_prompt": "Discussion Prompt",
  "attendees": "Attendees",
  "created_discussions": "Created Discussions",
  "grouped_discussions": "Grouped Discussions",
  "no_recordings_found": "No Recordings Found",
  "recordings": "Recordings",
  "scheduled_meetings": "Scheduled Meetings",
  "no_meetings_scheduled": "No Meetings Scheduled",
  "discussion_info": "Discussion Info",
  "invites": "Invites",
  "invited_members": "Invited Students",
  "minute": "Minute",
  "feedback": "Feedback",
  "view": "View",
  "no_data_found": "No Data Found",
  "no_past_discussions_found": "No Past Discussions Found",
  "no_submissions_found": "No Submissions Found",
  "background_images": "Background Images",
  "no_scheduled_discussions_found": "No Scheduled Discussions Found",
  "view_more": "View More",
  "past": "Past",
  "submissions": "Submissions",
  "join_live_game": "Join Live Game",
  "live_game_medals": "Live Game Medals",
  "live_game_medals_description": "Unlock medals by placing 1st, 2nd or 3rd during a Live Game",
  "classroom_has_no_live_game": "Classroom currently has no live game",
  "speech_recognition_error_info_no_phrase": "We did not recognise your phrase. We recommend that you reword the phrase and/or add an alternative version.",
  "no_conversation_available": "No Conversation Available",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "enrolment_key_min_chars": "Enrolment key must be at least 5 characters long",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "game_created": "Game created",
  "nuala_performance_rating": "Nuala Performance Rating",
  "using_nuala_performance": "If you use Nuala Performance Rating, you will lose any manually created grading.",
  "are_you_sure_nuala_performance": "Are you sure you want to use Nuala Performance Rating?",
  "play_live": "Play Live",
  "play_live_desc": "Select the exercise you'd like to play live in the classroom.",
  "live_dialog_description": "Select the exercise you'd like to play live in the classroom.",
  "select_exercise_phrases_intro": "Tick the phrase lists you want to play. You can mix lists from different courses.",
  "select_exercise_scenarios_intro": "Choose a scenario to play live with the class.",
  "source_type_phrase_lists": "Phrase lists",
  "source_type_scenarios": "Scenarios",
  "clear_all": "Clear All",
  "n_of_m_lists_selected": "{{n}} of {{m}} lists selected",
  "n_phrase_lists": "{{count}} phrase lists",
  "n_phrases": "{{count}} phrases",
  "has_definitions": "has definitions",
  "n_scenarios": "{{count}} scenarios",
  "n_messages": "{{count}} messages",
  "n_interactions": "{{count}} interactions",
  "lists_and_phrases_selected": "{{lists}} lists · {{phrases}} phrases",
  "no_lists_selected": "No lists selected",
  "no_scenario_selected": "No scenario selected",
  "scenario_selected": "Scenario selected",
  "number_of_messages": "Number of messages",
  "max_phrases_label": "Max",
  "max_phrases_all": "All {{count}}",
  "course_deletion_note": "*Note deleting this course will also delete the {{sectionCount}} section(s) in this course and its contents",
  "classroom_deletion_note": "*Note deleting this classroom will also delete the {{courseCount}} course(s) in this classroom and its contents",
  "topic_deletion_note": "*Note deleting this topic will also delete the {{phraseCount}} phrase(s), {{botCount}} chatbot(s) and {{roleplayCount}} scenario(s) in this topic and its contents",
  "section_deletion_note": "*Note deleting this section will also delete the {{topicCount}} topic(s) in this section and its contents",
  "confirmDeletionText": "To confirm deletion, type 'delete' into the field below",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "play_game": "Play Game",
  "close_game": "Close Game",
  "cancel_game": "Cancel Game",
  "end_game": "End Game",
  "games": "Games",
  "course_no_sections": "This course has no sections",
  "topic_no_phrases": "This topic has no phrases",
  "meaning_no_definitions": "This phrase list has no definitions",
  "next_question": "Next question",
  "your_answer": "Your answer",
  "change_answer": "Change answer",
  "final_results": "Results",
  "game_ended": "Game ended",
  "joined_game": "Joined game",
  "equipment_problem_label": "Equipment problem",
  "equipment_problem_example": "e.g. My speaker or microphone is not working",
  "technical_problem_label": "Technical problem",
  "technical_problem_example": "e.g. The app is not working correctly",
  "content_problem_label": "Content problem",
  "content_problem_example": "e.g. I noticed a mistake in the exercise content",
  "end_question_early": "End Question Early",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "timer_length": "Timer Length",
  "go_back_to_classroom": "Go back to Classroom",
  "discussion_created": "Discussion Created",
  "discussion_updated": "Discussion Updated",
  "give_feedback": "Give Feedback",
  "nualang_live_welcome": "Welcome to Nualang Live!",
  "nualang_live_invite": "Invite Students",
  "nualang_live_invite_desc": "Click here to see how students join the game.",
  "nualang_live_game_members": "Game Members",
  "nualang_live_game_members_desc": "Click here to see who hasn't joined the game yet.",
  "nualang_live_start_game": "Start the game!",
  "nualang_live_settings": "Game Settings",
  "nualang_live_settings_desc": "Click here to see game options",
  "keyboard_and_word_bank": "Keyboard and Word Bank",
  "keyboard_only": "Keyboard Only",
  "word_bank_only": "Word Bank Only",
  "answer_options": "Answer Options",
  "game_settings": "Game Settings",
  "create_feedback": "Create Feedback",
  "first_place": "First Place",
  "second_place": "Second Place",
  "third_place": "Third Place",
  "final_score": "Final Score",
  "no_discussions_found": "No Discussions Found",
  "no_discussions_found_desc": "All discussions and submissions can be found here",
  "quality_of_interaction": "Quality of Interaction",
  "number_of_questions": "Number of Questions",
  "estimated_game_time": "Estimated game time: {{time}}",
  "estimated_game_time_hint": "{{questions}} questions at {{seconds}}s each, plus feedback between rounds.",
  "n_minutes": "{{count}} minutes",
  "live_game_title": "{{exercise}} · {{count}} phrase lists",
  "phrases_from": "Phrases from",
  "source_card_meta": "{{topic}} · {{count}} phrases",
  "n_more": "more",
  "waiting_for_students": "Waiting for students to join.",
  "how_students_answer": "How students answer",
  "answer_keyboard_and_word_bank": "Keyboard and word bank",
  "answer_keyboard_and_word_bank_hint": "Students type, with word tiles as a fallback.",
  "answer_keyboard_only": "Keyboard only",
  "answer_keyboard_only_hint": "Hardest — students type the whole answer.",
  "answer_word_bank_only": "Word bank only",
  "answer_word_bank_only_hint": "Easiest — students tap words into place.",
  "time_per_question": "Time per question",
  "all_n_phrases": "All {{count}} phrases",
  "includes_one_from_each_list": "At least one phrase from each selected list is always included.",
  "minutes": "Minutes",
  "discuss": "Discuss",
  "open_live_game": "Open Live Game",
  "correct_answers": "Correct Answers",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "allow_wordBank": "Allow students to use the word bank in exercises",
  "creator_default": "Creator's default",
  "course_default": "Course default",
  "course_settings_description": "Adjust the learning experience for students of this classroom",
  "change_settings": "Change Settings",
  "choose_topic_from_pdf_for_roleplay": "Choose a topic for the scenario based on context from the course PDF",
  "use_context_from_course_pdf": "Use context from course PDF",
  "use_context_from_course_pdf_info": "Turn this on to be able to generate a scenario based on the contents of the course PDF if the  prompt is relevent to the contents in the PDF",
  "feedback_all_info": "Provides feedback to all students in the discussion group. You cannot provide both group and individual feedback to a student.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "rubric_info": "Rubric Info",
  "listen_to_story": "Listen to the Story",
  "roleplay_no_interactions": "This scenario has no interactions",
  "number_of_interactions": "Number of Interactions",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Discussion Templates",
  "discussion_templates_desc": "Use one of our predefined discussion templates, here to help you create content for your students",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "empty_live_dialog_description": "Add a course if you'd like to play live in the classroom.",
  "no_classroom_to_join": "Your teacher has not setup their classroom on Nualang yet. Please ask them to do so, then try again.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_welcome": "Discuss Guide",
  "discuss_scheduled_discussions": "Scheduled Discussions",
  "discuss_scheduled_discussions_desc": "This is where you will find scheduled discussions created by the teacher. You will be able to join these discussions and talk about a topic with other students in your group.",
  "discuss_refresh_discussions": "Refresh Discussions",
  "discuss_refresh_discussions_desc": "This button will allow you to refresh to get the latest discuss data.",
  "discuss_recorded_discussions": "Record Discussions",
  "discuss_recorded_discussions_desc": "Here you can find discussions you have recorded and submitted for the teacher to review. Once feedback is given you will be able to view it.",
  "discuss_grouped_discussions": "Grouped Discussions",
  "discuss_grouped_discussions_desc": "Here you can find all the discussions you have created for your students based on the topic name. Click into a grouped discussion to see what student groups were created.",
  "discuss_submissions": "Discussion Submissions",
  "discuss_submissions_desc": "Here you can find the recorded discussion submissions created by groups of students. You can view their recording, as well as the transcript of the discussions and give individual or grouped feedback.",
  "refresh_discuss": "Refresh Discuss",
  "nuala_ai": "Nuala AI",
  "performance_ratings": "Performance Ratings",
  "attended": "Attended",
  "did_not_attend": "Did Not Attend",
  "discussion_attendance": "Discussion Attendance",
  "submitted_recordings": "Submitted Recordings",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "nudge_add_family_name_title": "Add your last name",
  "go_to_settings": "Go to settings",
  "nudge_add_family_name_profile_desc": "We now support last names. Head to your profile to add yours.",
  "nudge_add_family_name_field_desc": "Enter your last name here so your full name shows across Nualang.",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "upload_video": "Upload Video",
  "select_video_desc": "Drag and drop a video from your computer",
  "add_video": "Add Video",
  "play_video": "Play Video",
  "video_info": "Course Video",
  "delete_video": "Delete Video",
  "delete_video_confirmation": "Are you sure you want to delete this video?",
  "view_video": "View Video",
  "video_options": "Video Options",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "pdf_options": "PDF Options",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "view_story": "View Story",
  "view_question": "View Question",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Scenario",
  "duplicate_roleplay": "Duplicate Scenario",
  "leave_game": "Leave Game",
  "leave_game_confirmation": "Are you sure you want to leave this game?",
  "leave": "Leave",
  "explore": "Explore",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "nualang_live_help": "How to play",
  "nualang_live_help_desc": "Click here to see how to play the game",
  "roleplay-story": "Story",
  "teach_classrooms_desc": "Manage and interact with your students in a dynamic learning environment",
  "teach_classrooms_title": "Engage Your Classroom",
  "teach_courses_desc": "Design and structure your curriculum to provide a complete learning experience",
  "teach_courses_title": "Build comprehensive courses",
  "teach_roleplays_title": "A new kind of Scenario",
  "teach_roleplays_desc": "Teaching with scenarios allows your students to participate in scripted conversations, providing a dynamic and immersive way to practice their language skills",
  "teach_bots_title": "Creativity with chatbots",
  "teach_bots_desc": "Teaching with chatbots can help your students develop confidence and a natural conversational style that flows seamlessly, similar to real-life conversations",
  "learn_bots_title": "Creativity with Chatbots",
  "learn_bots_desc": "Learning with chatbots can help you develop a natural and engaging conversational style that flows seamlessly, just like a real conversation",
  "learn_roleplays_title": "A new kind of Scenario",
  "learn_roleplays_desc": "Learning with scenarios allows you to participate in scripted conversations, providing a dynamic and immersive way to practice language skills",
  "learn_classrooms_desc": "Join classrooms where you can interact with your peers and teachers in a dynamic learning environment",
  "learn_classrooms_title": "Interactive Learning Spaces",
  "learn_courses_desc": "Enroll in courses designed to give you a complete learning experience with structured lessons and activities",
  "learn_courses_title": "Comprehensive learning paths",
  "video_included": "Video",
  "story_included": "Story",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "remove_question": "Remove Question",
  "supported_file_types": "Supported file types: mp4, mov",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "topic_no_roleplays": "This topic has no scenarios.",
  "case_sensitive": "This was marked for case sensitivity",
  "required_field": "Fields marked with * are required",
  "close_drawer": "Close Drawer",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "discuss_description": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "enable_discuss": "Enable Discuss in Settings",
  "incomplete_translation": "There is still more to this sentence!",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the scenario.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the scenario.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "enter_phrase_with_alternatives": "Enter a phrase with alternatives",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "archive_classroom": "Archive Classroom",
  "archive_classroom_confirmation": "Are you sure you want to archive this classroom?",
  "unarchive_classroom": "Unarchive Classroom",
  "unarchive_classroom_confirmation": "Are you sure you want to unarchive this classroom?",
  "confirmArchiveText": "To confirm archiving, type 'archive' into the field below",
  "confirmUnarchiveText": "To confirm unarchiving, type 'unarchive' into the field below",
  "generate_bot": "Generate Chatbot",
  "generating_bot": "Generating Chatbot",
  "choose_topic_for_bot": "What would you like this chatbot to be about?",
  "use_context_from_topic_phrases": "Use topic phrases",
  "generate_bot_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "voice_speed": "Voice Speed",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "topic_goal": "Communicative goal",
  "topic_goal_info_text": "What do you want the learner to be able to do at the end of this lesson?",
  "archived_classrooms_title": "No Archived Classrooms",
  "archived_classrooms_desc": "When you're finished with a classroom, you can archive it. This will archive the classroom for all students and collaborators.",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "ukrainian": "Ukrainian",
  "arabic": "Arabic",
  "chinese_simplified": "Chinese Simplified",
  "chinese_traditional": "Chinese Traditional",
  "czech": "Czech",
  "danish": "Danish",
  "dutch": "Dutch",
  "filipino": "Filipino",
  "greek": "Greek",
  "hindi": "Hindi",
  "hungarian": "Hungarian",
  "indonesian": "Indonesian",
  "japanese": "Japanese",
  "korean": "Korean",
  "malay": "Malay",
  "polish": "Polish",
  "punjabi": "Punjabi",
  "romanian": "Romanian",
  "swahili": "Swahili",
  "thai": "Thai",
  "turkish": "Turkish",
  "vietnamese": "Vietnamese",
  "speak_disabled": "Speak disabled",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "topic_goal_placeholder": "e.g I can ask and answer questions about my identity.",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "left_group": "Left Group",
  "view_feedback": "View Feedback",
  "no_feedback": "You have not given this student feedback yet",
  "app_search_placeholder": "Search community content",
  "search_topics_placeholder": "Search topics",
  "search_classrooms_placeholder": "Search classrooms",
  "delete_phrases": "Delete Phrases",
  "delete_phrases_confirmation": "Are you sure you want to delete the chosen phrases?",
  "share_audio": "Please uncheck this box if you do not want to share your audio with Nualang. Sharing the audio will help us diagnose the issue.",
  "edit_phrase": "Edit phrase",
  "share_screenshot": "Please check this box if you would like to share your screenshot with Nualang. Sharing the screenshot will help us diagnose the issue.",
  "screenshot_captured": "Screenshot captured:",
  "classroom_creator_play_live_game": "Play Nualang LIVE",
  "classroom_creator_play_live_game_desc": "Nualang LIVE offers customisable games that create a dynamic and engaging environment for students, allowing them to test their skills and compete against each other to win coveted Nuala medals.",
  "search_error": "An error occurred while searching, please try again",
  "create_feedback_error": "An error occurred while creating feedback, please try again",
  "get_recs_error": "An error occurred while getting recordings",
  "get_image_error": "An error occurred while getting images",
  "update_discussion_error": "An error occurred while updating discussion, please try again",
  "invite_users_error": "An error occurred inviting users, please try again",
  "create_image_error": "An error occurred while uploading image, please try again",
  "grade_conversation_error": "An error occurred while grading conversation, please try again",
  "get_transcript_error": "An error occurred while getting transcript, please try again",
  "get_subs_error": "An error occurred while getting submissions, please try again",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "schedule_discussion_error": "An error occurred scheduling the discussion, please try again",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "freely_changed": "This can be freely changed at any time.",
  "mark_as_challenge_student": "Enable Challenge Mode",
  "unmark_as_challenge_student": "Disable Challenge Mode",
  "mark_as_challenge_bot": "Mark as Challenge Mode",
  "unmark_as_challenge_bot": "Unmark as Challenge Mode",
  "challenge_student": "Challenge Mode",
  "challenge_student_desc": "Unlocks chatbots that prompt extended responses and formal, academic language. Designed with heritage learners in mind.",
  "challenge_bot": "Challenge Mode",
  "challenge_bot_desc": "This chatbot is visible only to students with Challenge Mode enabled in the Students tab. Designed with heritage learners in mind, it provides formal, academic prompts.",
  "rewatch_tutorial": "Rewatch Tutorial",
  "heritage_speaker_progress": "Students marked as 'Read/Write' will have their learning experience adjusted to focus more on reading and writing.",
  "generate_transcript": "Generate Transcript",
  "suggested_images": "Suggested Images",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "assign_discuss": "Assign Discuss",
  "assign_discuss_desc": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "Student manually edited this transcript after recording.",
  "member_updated": "Student updated",
  "delete_assignment": "Delete Assignment",
  "delete_assignment_confirmation": "Are you sure you want to delete this assignment?",
  "assignment_deleted": "Assignment deleted",
  "assignment_created": "Assignment created",
  "assignees_created": "Assignees created",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "report_type": "Type",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "not_assigned": "Not Assigned",
  "assigned": "Assigned",
  "view_assignment": "View Assignment",
  "no_assignments_description": "There are currenly no assignments created.",
  "no_shared_courses": "There are no shared courses between the selected classrooms.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "generated_phrases": "Are you sure you want to add the following generated phrases to the list? These phrases will be appended and will not replace any existing phrases.",
  "everyone": "Everyone",
  "discussions": "Discussions",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "hello": "Hello",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "ai_chatbot_message_info": "This chatbot message is generated using AI.",
  "ai_chatbot_message_generating_info": "This chatbot message is being generated using AI.",
  "language_correction": "Language Correction",
  "correction_original": "Original",
  "correction_suggested": "Suggested",
  "language_corrections_to_review": "Language corrections to review",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "paste_your_csv_data": "Paste your CSV data here",
  "user_level_settings": "User Level Settings",
  "chatbot_dynamic_responses": "Chatbot - Dynamic Responses",
  "chatbot_dynamic_responses_desc": "If dynamic response is turned on, the Chatbots will actively listen and adapt, prompting for more detail, clearer phrasing, or realistic answers, instead of just moving to the next scripted prompt.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "The transcript below requires your review.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "A student acts inappropriately during a Chatbot exercise",
  "ai_chatbot_error_response": "Sorry I made a mistake in my response. Please try again!",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "generate_feedback_for_all": "Generate Feedback for All",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "this_classroom_is_archived": "This classroom is archived",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "submit_feedback_confirmation": "Have you reviewed all generated feedback and are you ready to submit it to students?",
  "submit_feedback_scroll": "Review all feedback before submitting it to students",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "generating_feedback": "Generating Feedback",
  "conversations_graded_success": "Feedback Generated",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "you_are_human": "If you are human, leave this field blank",
  "progress": "progress",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "chinese": "Chinese",
  "custom_feedback_placeholder": "Optional: Add additional instructions to focus the feedback (e.g. accuracy, complexity, or use of target structures).",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "meaning-listen-and-speak": "Meaning - Listen & Speak",
  "meaning_listen_and_speak_exercise_desc": "Listen to the definition and speak the matching phrase.",
  "meaning-read-and-write": "Meaning - Read & Write",
  "select_the_correct_phrase": "Select the correct phrase for this definition",
  "generate_feedback_view_the": "View the",
  "generate_feedback_rubric_name": "Analytic Growth Rubric",
  "generate_feedback_rubric_desc": "the criteria being used in our AI feedback.",
  "late_submission": "Late Submission",
  "days_late_one": "{{count}} day late",
  "days_late_other": "{{count}} days late",
  "phrase_definition": "Phrase Definition",
  "phrase_definition_helper_text": "Press enter / return key to add definition.",
  "generate_definitions": "Generate Definitions",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Phrase Lists",
  "no_phrase_lists": "No Phrase Lists",
  "all_phrase_lists": "All Phrase Lists",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "There was a problem generating definitions. Please try again.",
  "saving_defintions_error": "There was a problem saving definitions. Please try again.",
  "auto_generate_definitions": "Generate Definitions",
  "generating_definitions": "Generating Definitions",
  "definitions": "Definitions",
  "view_phrase_list": "View Phrase List",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "Copy to",
  "transfer": "Copy",
  "create_phrase_list_from_selection": "Create New Phrase List",
  "no_other_phrase_lists": "No other phrase lists",
  "add_row": "Add Row",
  "problem_updating": "There was a problem updating",
  "exercise_settings": "Exercise Settings",
  "excercise_voice": "Exercise Voice",
  "excercise_voice_desc": "Select the voice that will be used in exercises for this phrase list.",
  "excercise_visibility": "Exercise Visibility",
  "keyboard": "Keyboard",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "Welcome to the Read & Write Exercise",
  "read_write_exercise_definition": "Definition",
  "read_write_exercise_definition_desc": "Read the definition shown here",
  "read_write_exercise_options": "Type the Phrase",
  "read_write_exercise_options_desc": "Type the correct phrase in the text box",
  "read_the_definition": "Read the definition",
  "type_the_correct_phrase": "Type the correct phrase",
  "read_write": "Read & Write",
  "meaning_read_write": "Meaning - Read & Write",
  "meaning_read_write_exercise_desc": "Read the definition and type the correct phrase.",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "Create Chatbot",
  "find_chatbot": "Find Chatbot",
  "find_chatbots": "Find Chatbots",
  "add_chatbot": "Add Chatbot",
  "add_chatbots": "Add Chatbots",
  "template": "Template",
  "chatbot_name": "Chatbot Name",
  "chatbot_title": "Chatbot Title",
  "create_scenario": "Create Scenario",
  "find_scenario": "Find Scenario",
  "find_scenarios": "Find Scenarios",
  "scenario_name": "Scenario Name",
  "scenarios_added": "Scenarios added to topic",
  "chatbots_added": "Chatbots added to topic",
  "add_scenarios": "Add Scenarios",
  "achievements": "Achievements",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "Find topics made by other teachers in the <1>Community</1> tab.",
  "open_ended": "Open Ended",
  "open_ended_desc": "Let your students respond in their own words.",
  "quiz": "Quiz",
  "quiz_desc": "Guide the student through a series of questions.",
  "picture_quiz": "Picture Quiz",
  "picture_quiz_desc": "Ask questions based on pictures.",
  "emoji_quiz": "Emoji Quiz",
  "emoji_quiz_desc": "Guess the answer based on the emojis.",
  "quiz_style_templates": "Quiz-Style Templates",
  "no_scenarios_found": "No scenarios found",
  "no_chatbots_found": "No chatbots found",
  "use_voice": "Use Voice",
  "internal_view_provider_marks": "Internal View · Provider Marks Visible",
  "legacy": "Legacy",
  "search_sections_and_topics": "Search sections and topics",
  "clear_search": "Clear search",
  "x_of_y": "{{shown}} of {{total}}",
  "outline_filter_count": "{{topics}} in {{sections}}",
  "topic_count_one": "{{count}} topic",
  "topic_count_other": "{{count}} topics",
  "section_count_one": "{{count}} section",
  "section_count_other": "{{count}} sections",
  "no_sections_or_topics_match": "No sections or topics match",
  "try_different_keyword_or_difficulty": "Try a different keyword or difficulty.",
  "nothing_matches_keyword_at_difficulty": "Nothing matches “{{keyword}}” at {{difficulty}} difficulty. Try another keyword or difficulty.",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "session_feedback": "Your feedback",
  "session_feedback_preparing": "Preparing your feedback…",
  "session_feedback_unavailable": "Your feedback isn't available right now.",
  "suggested_level": "Suggested level",
  "session_report": "Conversation feedback",
  "view_full_report": "View full feedback",
  "rating_approaching": "Approaching",
  "rating_meets": "Meets",
  "rating_exceeds": "Exceeds",
  "area_of_strength": "Area of strength",
  "area_for_growth": "Area for growth",
  "rating_not_yet": "Not yet",
  "session_report_short_interaction": "Interaction",
  "session_report_short_vocabulary": "Vocabulary",
  "session_report_short_function": "Function",
  "session_report_strength": "Strength",
  "session_report_growth": "Growth",
  "ai_generated_report": "AI-generated feedback",
  "ai_generated_report_tooltip": "Generated by AI from this session only. The suggested level and ratings are estimates, not a final placement.",
  "session_report_new": "New",
  "chatbot_mode_name": "Chatbot - {{mode}}",
  "chatbot_message_count": "{{count}} messages",
  "chatbot_message_count_one": "{{count}} message",
  "chatbot_message_count_other": "{{count}} messages",
  "attempt_count": "{{count}} attempts",
  "attempt_count_one": "{{count}} attempt",
  "attempt_count_other": "{{count}} attempts",
  "of_total_correct": "of {{total}} correct",
  "attempts_to_review": "Attempts to review",
  "attempts_not_shown": "{{items, list}} attempts not shown",
  "count_correct": "{{count}} correct",
  "count_incorrect": "{{count}} incorrect",
  "count_skipped": "{{count}} skipped",
  "count_partially_correct": "{{count}} partially correct",
  "view_all_count": "View all {{count}}",
  "view_attempt": "View attempt",
  "scenario_description_default": "This is a scenario to help students speak {{learnLang}} with confidence."
}
